import { CommonModule } from '@angular/common';
import { Injectable, NgModule, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  BodySchemaActionLoadBodySchema,
  selectorBodySchemaColor
} from '@bepatient/body-schema-store';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CorePageModule,
  CorePageModuleIDs,
  CoreSelectorGuard
} from '@bepatient/core';
import { IonicModule } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { BodySchemaButtonComponent } from './components/body-schema-button/body-schema-button.component';
import { BodySchemaPainPopupComponent } from './components/body-schema-pain-popup/body-schema-pain-popup.component';

@Injectable()
export class BodySchemaGuard extends CoreSelectorGuard {
  constructor() {
    const store = inject<Store<any>>(Store);

    super(
      store,
      selectorBodySchemaColor,
      new BodySchemaActionLoadBodySchema(),
      ['/body-schema-details', '/body-schema-mouth', '/body-schema-pelvic']
    );
  }
}

const bodySchemaModule: CorePageModule = {
  ID: CorePageModuleIDs.BODY_SCHEMA,
  i18nLabel: 'MODULES.BODY_SCHEMA',
  icon: 'copy',
  leftMenuAvailableForPages: [0, 1, 2, 3, 4, 5],
  routes: [
    {
      path: 'body-schema',
      canActivate: [BodySchemaGuard],
      loadChildren: () =>
        import('./pages/body-schema/body-schema.module').then(
          m => m.BodySchemaPageModule
        )
    },
    {
      path: 'body-schema-details',
      loadChildren: () =>
        import('./pages/body-schema-details/body-schema-details.module').then(
          m => m.BodySchemaDetailsModule
        )
    },
    {
      path: 'body-schema-mouth',
      loadChildren: () =>
        import('./pages/body-schema-mouth/body-schema-mouth.module').then(
          m => m.BodySchemaMouthModule
        )
    },
    {
      path: 'body-schema-pelvic',
      loadChildren: () =>
        import('./pages/body-schema-pelvic/body-schema-pelvic.module').then(
          m => m.BodySchemaPelvicModule
        )
    }
  ]
};

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    RouterModule.forChild(bodySchemaModule.routes)
  ],
  providers: [
    BodySchemaGuard,
    { provide: CORE_PAGE_MODULE, useValue: bodySchemaModule, multi: true },
    { provide: CORE_I18N_FOLDER, useValue: './body-schema/i18n/', multi: true }
  ],
  declarations: [BodySchemaButtonComponent, BodySchemaPainPopupComponent],
  exports: [BodySchemaButtonComponent]
})
export class BodySchemaModule {}
